import { ReactNode } from 'react';
import { Root } from './styles';

export interface KeyProps {
  children: ReactNode;
  className?: string;
}

const Key = ({ children, className }: KeyProps) => {
  return <Root className={className}>{children}</Root>;
};

export default Key;
